// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2ejwW","itemA":"Write_itemA__19RBU","itemB":"Write_itemB__3Mgdt","itemC":"Write_itemC__2tnRo","itemD":"Write_itemD__3rG65"};